"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_TAGS = exports.GET_ADVERTISEMENT_BY_ID = exports.GET_ADVERTISEMENTS = exports.ButtonTarget = exports.AdvertisementTagKey = void 0;
var AdvertisementTagKey;
(function (AdvertisementTagKey) {
    AdvertisementTagKey["MOBILE_FEATURED"] = "MOBILE_FEATURED";
    AdvertisementTagKey["WEB_FEATURED"] = "WEB_FEATURED";
})(AdvertisementTagKey || (exports.AdvertisementTagKey = AdvertisementTagKey = {}));
var ButtonTarget;
(function (ButtonTarget) {
    ButtonTarget["DEEP_LINK"] = "DEEP_LINK";
    ButtonTarget["INTERNAL"] = "INTERNAL";
    ButtonTarget["EXTERNAL"] = "EXTERNAL";
})(ButtonTarget || (exports.ButtonTarget = ButtonTarget = {}));
const GET_ADVERTISEMENTS = 'media/GET_ADVERTISEMENTS';
exports.GET_ADVERTISEMENTS = GET_ADVERTISEMENTS;
const GET_ADVERTISEMENT_BY_ID = 'media/GET_ADVERTISEMENT_BY_ID';
exports.GET_ADVERTISEMENT_BY_ID = GET_ADVERTISEMENT_BY_ID;
const GET_TAGS = 'media/GET_TAGS';
exports.GET_TAGS = GET_TAGS;
//# sourceMappingURL=types.js.map